// @flow

import * as React from "react"
import message from "shared/utils/message"
import IntlStore from "shared/stores/IntlStore"
import get from "lodash/get"
import ErrorDetails from "./ErrorDetails"

function messageError(app: string, e: Object): void {
  if (
    !e.response ||
    !e.response.data ||
    !e.response.data.errors ||
    e.response.data.errors instanceof Array === false
  ) {
    const errorMessage =
      get(e, "response.data.message") ||
      get(e, "message") ||
      IntlStore.formatMessage("error.UNKNOWN")

    return message.error(errorMessage)
  }

  const errors = e.response.data.errors
  const errorMessages = []

  errors.forEach(error => {
    errorMessages.push(
      <p key={error.code}>
        {IntlStore.formatMessage(`apps.${app}.error.${error.code}`, {
          message: error.message
        })}
      </p>
    )
  })

  message.error(
    <React.Fragment>
      {errorMessages}
      <ErrorDetails error={e} />
    </React.Fragment>
  )
}

function messageErrorWithoutTranslation(e: Object) {
  const errors = get(e, "response.data.errors", [])

  if (errors.length === 0) {
    message.error(IntlStore.formatMessage("error.UNKNOWN"))
  }
  const errorMessages = []

  errors.forEach(error => {
    errorMessages.push(<p key={error.code}>{error.message}</p>)
  })
  message.error(<React.Fragment>{errorMessages}</React.Fragment>)
}

export { messageError, messageErrorWithoutTranslation }
